module.exports = __webpack_public_path__ + "img/background.9ceb336a.jpg";